{
  "title": "Spray of Cards (UA)",
  "source": "Unearthed Arcana 85 - Wonders of the Multiverse",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "15-foot cone",
  "components": "V, S, M (a deck of cards)",
  "duration": "Instantaneous",
  "description": [
    "You spray spectral cards from your hands or sleeve; the cards blind or slash at your enemies, and then vanish. Choose one of the following effects for the cards:",
    "Blinding Cards. Each creature in a 15-foot cone must succeed on a Wisdom saving throw or be blinded until the end of their next turn.",
    "Cutting Cards. Each creature in a 15-foot cone must make a Dexterity saving throw. A creature takes 2d10 force damage on a failed save or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage of cutting cards increases by 1d10 for every two slot levels above 2nd"
  ],
  "spellLists": ["bard", "sorcerer", "warlock", "wizard"]
}
